import { DirectoryItemType } from '@magicbrief/common';
import { BaseTranslation } from 'typesafe-i18n';

const directoriesList: Record<DirectoryItemType | 'DirectoryNode', string> = {
  DirectoryNode: 'Boards',
  OrganisationAd: 'Ads',
  BrandProfile: 'Brand Profiles',
  ProductProfile: 'Product Profiles',
  Brief: 'Briefs',
  InsightsAdFacebook: 'Insights Ads',
  UserAsset: 'Assets',
  Storyboard: 'Storyboard',
};

export const directories: BaseTranslation = {
  ...directoriesList,
  empty: {
    title: 'Nothing to see here',
    description:
      'To get started, try pinning some items to this board, or create some sub-boards.',
  },
  sortOptions: {
    updatedAt: 'Recently updated',
    createdAt: 'Newest first',
    type: 'By type',
    adScore: 'Performance Estimate',
    adLongevity: 'Longest running',
  },
};
